import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#FDFBF7]" data-testid="payment-cancel-page">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-lg w-full border border-[#E5DFD3] p-10 lg:p-14"
      >
        <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#4A148C] mb-3">Checkout cancelled</p>
        <h1 className="font-serif text-5xl font-light tracking-tighter leading-none">
          Changed your <span className="italic">mind?</span>
        </h1>
        <p className="mt-6 text-sm font-light leading-relaxed text-[#1A1A1A]/60">
          No worries — your basket is saved exactly as you left it. The Proppadoms will wait.
        </p>
        <Link
          to="/"
          data-testid="cancel-back-to-shop-link"
          className="mt-10 inline-block bg-[#1A1A1A] text-[#FDFBF7] px-8 py-4 text-xs font-semibold tracking-[0.2em] uppercase hover:bg-[#4A148C] transition-colors duration-300"
        >
          Back to the shop
        </Link>
      </motion.div>
    </div>
  );
}
